<template>
  <div ref="productItem" class="buttons-bottom-header__product jsFavoriteProduct">
    <a :href="item.DETAIL_PAGE_URL" class="buttons-bottom-header__thumbnail-link">
      <v-picture :image="item.DETAIL_PICTURE" add-class="buttons-bottom-header__thumbnail-img" />
    </a>
    <p class="buttons-bottom-header__title">
      <a :href="item.DETAIL_PAGE_URL" v-html="item.NAME" />
    </p>
    <button
      class="buttons-bottom-header__delete-btn jsDeleteFavorite favorite active" @click="deleteItem(item.ID)"
    >
      <img src="/local/front/dist/content/delete-button-icon.svg">
    </button>
  </div>
</template>
<script>
import VPicture from '@/components/v-picture.vue';

export default {
  name: 'app',
  components: { VPicture },
  props: {
    item: {
      type: Object,
      default() {
        return {
          ID: 0,
          NAME: '',
          DETAIL_PICTURE: {},
          DETAIL_PAGE_URL: '',
        };
      },
    },
  },
  methods: {
    deleteItem(id) {
      this.$emit('deleteItem', id, this.$refs.productItem);
    },
  },
};
</script>
